import EventBus from "../store/event-bus";

export default {
  data() {
    return {
      columnDefs: null,
      agContext: {},
    };
  },

  computed: {
    showAgGrid() {
      return this.$store.getters.localSettings(
        `${this.refNameColumns}-showAg`,
        false
      );
    },
    agridColumnsState() {
      const lastSort = this.$store.getters.localSettings(
        `${this.refName}-sort`,
        {
          fieldName: "id",
          direction: "DESC",
        }
      );
      const columnsState = this.$store.getters.localSettings(
        `${this.refNameColumns}-agGridColState`,
        []
      );

      return columnsState.map((c) => {
        if (c.colId == lastSort.fieldName) {
          return { ...c, sort: lastSort.direction.toLowerCase() };
        } else {
          return { ...c, sort: null };
        }
      });
    },
    agGridColumns() {
      const cols = [
        ...this.filteredHeaders.map((h) => ({
          headerName: h.text,
          field: h.name,
          sortable: h.sortable,
          valueGetter: h.valueGetter ? h.valueGetter : undefined,
          valueFormatter: h.valueFormatter ? h.valueFormatter : undefined,
          comparator: h.comparator ? h.comparator : undefined,
          resizable: true,
          cellRendererFramework: h.cellRendererFramework,
          editable: h.editable,
          cellEditor: h.cellEditor,
          cellRenderer: h.cellRenderer,
          width: h.width ? h.width : undefined,
        })),
      ];

      return cols;
    },
  },

  methods: {
    onAgGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      if (this.agridColumnsState && this.agridColumnsState.length > 0) {
        this.columnApi.applyColumnState({
          state: this.agridColumnsState,
          applyOrder: true,
        });
      } else {
        //params.api.sizeColumnsToFit();
      }
      EventBus.$emit("add-infinite-scroll");
    },

    updateAgGridColumns() {
      // if (this.showAgGrid && this.gridApi) {
      //   this.gridApi.sizeColumnsToFit();
      // }
    },
    onAgColumnMoved(payload) {
      const columnState = payload.columnApi.getColumnState();

      this.$store.dispatch("updateLocalSettings", {
        [`${this.refNameColumns}-agGridColState`]: columnState,
      });
      //update standard grid columns
      // this.visibleColumns = columnState.map((c) => c.colId);
      this.visibleColumns = columnState.map((c) => c.colId);
      this.$store.dispatch("updateLocalSettings", {
        [`${this.refNameColumns}`]: columnState.map((c) => c.colId),
      });
    },
    onAgColumnResized(payload) {
      if (payload.finished) {
        const columnState = payload.columnApi.getColumnState();
        this.$store.dispatch("updateLocalSettings", {
          [`${this.refNameColumns}-agGridColState`]: columnState,
        });
      }
    },
    onAgSortChanged(event) {
      const sortByColumn = event.columnApi
        .getColumnState()
        .find((col) => col.sort != null);

      if (sortByColumn) {
        if (
          sortByColumn.colId != this.sort.fieldName ||
          sortByColumn.sort.toUpperCase() != this.sort.direction
        ) {
          this.sort = {
            fieldName: sortByColumn.colId,
            direction: sortByColumn.sort.toUpperCase(),
          };

          this.gridApi.showLoadingOverlay();
        }
      } else {
        this.sort = { fieldName: "id", direction: "DESC" };
      }
      const refNameSort = this.refName
        ? `${this.refName}-sort`
        : `${this.$options.name}-sort`;
      //console.log("updating", refNameColumns);

      this.$store.dispatch("updateLocalSettings", {
        [refNameSort]: { ...this.sort },
      });
    },
    onAgSelectionChanged(event) {
      if (this.gridApi) {
        this.selected = this.gridApi
          .getSelectedNodes()
          .map((rowNode) => ({ ...rowNode.data }));
      }
    },
    onAgNewColumns(payload) {
      //payload.api.sizeColumnsToFit();
    },
    updateAgGridData() {
      if (this.gridApi) {
        this.gridApi.refreshCells();
      }
    },
  },

  beforeMount() {
    this.agContext = { componentParent: this };
  },

  mounted() {
    window.addEventListener("resize", this.updateAgGridColumns);
  },

  destroyed() {
    window.removeEventListener("resize", this.updateAgGridColumns);
  },
};



// WEBPACK FOOTER //
// ./src/mixins/AgGridListMixin.js